/** PrimeIcons class strings allowed for sidebar layout (keep in sync with platform navigation-icons). */
export const ALLOWED_NAVIGATION_ICONS = [
  'pi pi-home',
  'pi pi-list',
  'pi pi-history',
  'pi pi-flag',
  'pi pi-map',
  'pi pi-bookmark',
  'pi pi-bullseye',
  'pi pi-comments',
  'pi pi-users',
  'pi pi-chart-line',
  'pi pi-book',
  'pi pi-briefcase',
  'pi pi-shield',
  'pi pi-user',
  'pi pi-cog',
  'pi pi-file-edit',
  'pi pi-circle',
  'pi pi-calendar',
  'pi pi-check',
  'pi pi-clock',
  'pi pi-database',
  'pi pi-envelope',
  'pi pi-exclamation-triangle',
  'pi pi-globe',
  'pi pi-heart',
  'pi pi-image',
  'pi pi-inbox',
  'pi pi-info-circle',
  'pi pi-link',
  'pi pi-lock',
  'pi pi-map-marker',
  'pi pi-pencil',
  'pi pi-plus',
  'pi pi-search',
  'pi pi-send',
  'pi pi-star',
  'pi pi-table',
  'pi pi-tag',
  'pi pi-th-large',
  'pi pi-trash',
  'pi pi-video',
  'pi pi-wallet',
];

export const DEFAULT_NAVIGATION_ICON_BY_CATALOG_KEY = {
  home: 'pi pi-home',
  activities: 'pi pi-list',
  travelBuddyHistory: 'pi pi-history',
  personalGoals: 'pi pi-flag',
  personalJourney: 'pi pi-map',
  reflexionGuideline: 'pi pi-bookmark',
  externalEvaluation: 'pi pi-bullseye',
  kssTracker: 'pi pi-comments',
  workshops: 'pi pi-users',
  myResults: 'pi pi-chart-line',
  teamResults: 'pi pi-users',
  knowledgeDatabase: 'pi pi-book',
  managementDashboard: 'pi pi-briefcase',
  administration: 'pi pi-shield',
  userAdministration: 'pi pi-user',
  teamAdministration: 'pi pi-users',
  admin: 'pi pi-cog',
};
